import { ca } from '@cian/analytics';

export const trackMenuActionClick = (analyticsType: string, analyticsSours: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: analyticsType,
    page: {
      extra: {
        chat_id: 'chatbot',
        click_source: analyticsSours,
      },
    },
  });
};

export const trackMenuClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'Menu',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};
